import styled from "@emotion/styled";

import SelectT1 from "Components/Common/Select/SelectT1";

import { Wrapper } from "Components/Common/Wrapper/index";
import { DateRangePicker } from "react-dates";
import React, { Fragment } from "react";
import InputT1 from "Components/Common/Input/InputT1";
import { isDesmetSupplier } from "Utils/index";



const FilterBox = (props) => {
  const {
    handleOnChangeForSearch,
    search,
    supplierNameList,
    selectSupplierName,
    handleOnChangeForSupplierName,
    transporterMappingList,
    selectedTransporterNameItem,
    handleOnChangeForTransporterName,
    activeStatusTabBtnId,
    startDate,
    endDate,
    dateRangeFocused,
    handleOnChangeForDateRangeFocused,
    handleOnChangeForDateRange
    
  } = props;

  const shouldRenderTransporterNameDropdown = ()=>{
     const C1  = isDesmetSupplier()
     const C2  = activeStatusTabBtnId === 5 

    if(C1 && C2){
      return true
    }
    return false
  }

  return (
    <Fragment>
      <FilterBoxWrapper>
        <Wrapper>
          <DateRangePicker
          displayFormat={"DD/MM/YYYY"}
          startDate={startDate} 
          startDateId="startDate" 
          endDate={endDate} 
          endDateId="endDate" 
          onDatesChange={
            ({ startDate, endDate }) => {
              handleOnChangeForDateRange( startDate, endDate)
            }
          } 
          focusedInput={dateRangeFocused}
          onFocusChange={(focused)=>{
            handleOnChangeForDateRangeFocused(focused)
          }} 
          isOutsideRange={() => false}
          />
        </Wrapper>
        <Wrapper>
          <InputT1 
            placeholder={"Search here"}
            onChange={handleOnChangeForSearch}
            value={search}
           />
         </Wrapper>
         {!isDesmetSupplier() && (
          <Wrapper>
            <SelectT1
              placeholder={"Suppliers"}
              isClearable={true}
              options={supplierNameList}
              isSearchable={true}
              value={selectSupplierName}
              onChange={handleOnChangeForSupplierName}
            />
          </Wrapper>
        )}  
        {shouldRenderTransporterNameDropdown () && (
          <Wrapper>
            <SelectT1
              placeholder={"Transporter"}
              isClearable={true}
              options={transporterMappingList}
              isSearchable={true}
              value={selectedTransporterNameItem}
              onChange={handleOnChangeForTransporterName}
            />
          </Wrapper>
        )}  
     
      </FilterBoxWrapper>
    </Fragment>
  );
};

export default FilterBox;

const FilterBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  wrap: flex-wrap;
`;

// const LeftSideWrapper = styled(Wrapper)`
//   display: flex;
//   gap: 24px;
//   flex-wrap: wrap;
//   flex: 1;
// `;
// const RightSideWrapper = styled(Wrapper)`
//   display: flex;
// `;

// const LineT1 = styled.div`
//   border-bottom: 1px solid #fff;
//   width: 100%;
//   height: 1px;
// `;
// const MoreWrapper = styled(Wrapper)``;
